import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { PairInformationCurrency } from '@root/entities/pair/ui'

import { DistributeTableCurrencyProgress } from './distribute-table-currency-progress'

import type { PairPerformance } from '../../model'

type Props = {
  value: PairPerformance
}

export const DistributeTableStackedCell: React.FC<Props> = React.memo(
  ({ value }) => {
    const { t } = useTranslation()
    return (
      <Root>
        <PairInformationCurrency
          pair={value.pair}
          withSocials
          withAge
          withProvider
          withBoosters
          withDevTokens
        />
        <Group>
          <Label variant="body4-regular">{t('common.realized')}</Label>
          <DistributeTableCurrencyProgress value={value} placement="inline" />
        </Group>
      </Root>
    )
  },
)

const Root = styled.div`
  display: grid;
`

const Group = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
`

const Label = styled(Typography)`
  color: var(--text-9);
  margin-top: 9px;
`
